<div class="card">
    <div class="card-header">
      <h4>Smart Router</h4>
    </div>
    <div class="card-body m-0">
        <div class="row d-flex">
            <div class="form-group col-md-3">
              <label class="col-form-label" for="userType">Product</label>                      
              <ng-select id="userType" placeholder="Select Product" [(ngModel)]="selectedProduct" name="selectedProduct">
                <ng-option *ngFor="let product of productList" value="{{product.value}}">{{product.name}}</ng-option>
              </ng-select>   
            </div>
            <div class="form-group col-md-3">
                <label class="col-form-label" for="selectedCountry">Country</label>                      
                <ng-select id="selectedCountry"  placeholder="Select Country" [(ngModel)]="selectedCountry">
                  <ng-option *ngFor="let country of countryList" value="{{country.value}}">{{country.name}}</ng-option>
                </ng-select>   
            </div>
            <div class="form-group col-md-1 mt-4">
              <!-- <div class="text-right"> -->
                <button type="button" class="btn btn-primary">Submit</button>
              <!-- </div> -->
          </div>
          <br>
        </div>
    </div>
    <div class="card-body m-0">
        <div class="row d-flex">
            <div class="form-group col-md-3">
                <label class="col-form-label">Calculation Formula Logic : </label>                      
            </div>
            <div class="form-group col-md-6">
                <input readonly type="text" class="form-control" [value]="formula">  
            </div>
        </div>
    </div>
    <div class="row mb-0" style="min-height: 470px">
        <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
          <ag-grid-angular [enableCellTextSelection]=true (sortChanged)="onSortChange($event)"
            (filterChanged)="onFilterChange($event)" (filterModified)="onFilterModified($event)" [gridOptions]="gridOptions"
            (filterOpened)="onFilterOpened($event)" (gridReady)="onGridReady($event)"
             (search)="globalSearch" [columnDefs]="tableSelectedColumn"
            [defaultColDef]="defaultColDef" [enableCellTextSelection]=true [paginationPageSize]="pageSize"
            [pagination]="true" [rowData]="rowData" [rowModelType]="" [rowSelection]="'single'"
            [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
          </ag-grid-angular>
        </div>
      </div>
      <div class="row mt-0">
        <div class="col-4 col-xs-4">
          <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
            class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
            <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
  
          </select>
        </div>
  
        <div class="col-8 col-xs-8">
          <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
            [collectionSize]="collectionSize" [maxSize]="maxSize" [pageSize]="pageSize" [rotate]="true"
            [ellipses]="ellipses" size="sm" class="d-flex justify-content-end align-right">
          </ngb-pagination>
        </div>
      </div>